module.exports = __webpack_public_path__ + "img/3-2.47771f1f.png";